<div class="modal-dialog modal-dialog-centered">
    <div class="modal-content">
      <div class="modal-header">
        <h6 class="modal-title h6">{{ 'orguseradd.header' | trans }}</h6>
        <button #closemodal (click)="resetModal()" type="button" class="close" data-dismiss="modal">&times;</button>
      </div>
      <div class="modal-body">
        <app-loadconfirm *ngIf="showSpinner" [text]="'orguseradd.loadconfirmcreate'| trans " [icon]="'person_add'"></app-loadconfirm>
        <div class="row">
          <div class="col">
            <form class="form-signin" action="#" role="form">
              <div *ngIf="errorMessage!=null" class="alert alert-danger ml-0 mr-0">
                  <h6 class="error-msg">{{ errorMessage | trans }}</h6>
              </div>
              <div *ngIf="showSuccess" class="alert alert-success" role="alert">
                {{ 'orguseradd.usercreationcomplete' | trans }}
              </div>
              <div class="form-group">
                  <p class="mb-0" for="signupName">{{ 'orguseradd.name' | trans }}</p>
                  <input id="signupName"  type="text" maxlength="50" 
                  class="form-control" name="fullname" [(ngModel)]="registrationUser.name" required>
              </div>
              <div class="form-group">
                  <p class="mb-0" for="signupJobTitle">{{ 'orguseradd.jobtitle' | trans }}</p>
                  <input id="signupJobTitle"  type="text" maxlength="50" 
                  class="form-control" name="jobtitle" [(ngModel)]="registrationUser.jobtitle" required>
              </div>
              <div class="form-group">
                  <p class="mb-0" for="signupEmai">{{ 'orguseradd.email' | trans }}</p>
                  <input [ngClass]="{'customvalidator-invalid': emailfieldValidator == false, 'customvalidator-valid': emailfieldValidator == true }" id="signupEmail" type="email" (ngModelChange)="onEmailChange($event)" maxlength="50" 
                  class="form-control" name="email" [(ngModel)]="registrationUser.email"  required>
              </div>

              <!---PHONE NUMBER 
                  <div class="form-group ">
                  <label class="control-label" for="signupPhone">Phone</label>
                  <input id="signupPhone"  type="text"  maxlength="50" class="form-control" name="phone" [(ngModel)]="createCustomerUser.phone" >
              </div>-->

              <div class="form-group ">
                  <p class="mb-0" for="signupUsername">{{ 'orguseradd.username' | trans }}</p>
                  <input [ngClass]="{'customvalidator-invalid': userfieldValidator == false, 'customvalidator-valid': userfieldValidator == true }" (keyup)="checkForm()" id="signupUsername" type="text" maxlength="50" 
                  class="form-control" name="username" (ngModelChange)="onUsernameChange($event)" [(ngModel)]="registrationUser.username" required >
              </div>
              <div *ngIf="!userfieldValidator" class="alert alert-secondary f-13">
                {{ 'orguseradd.usernamealert' | trans }}
              </div>
              <!--div class="form-group ">
                <label class="control-label" for="signupPw">Password</label>
                <input id="signupPw"  type="text"  maxlength="50" 
                class="form-control" name="pw" [(ngModel)]="registrationUser.password"  >
            </div-->
              <!---INVITATION BY EMAIL OPTION-->
      <hr>
                <div class="form-group cursor-pointer" (click)="orguseraddsendemail()">
                      <div class="row mb-1">
                        <p class="mb-0 invite-label mr-2">{{ 'orguseradd.sendemailinvitation' | trans }}</p>
                        <div class="form-check form-check-inline">
                          <input class="form-check-input" type="checkbox" id="inlineCheckbox1" name="invite" [(ngModel)]="registrationUser.invite" >
                        </div>
                    </div>
                      <div *ngIf="!registrationUser.invite" class="alert alert-secondary f-13">
                        {{ 'orguseradd.createusersendemailalert' | trans }}
                      </div>
                      <div *ngIf="registrationUser.invite" class="alert alert-success f-13">
                        {{ 'orguseradd.createusersendemailalert2' | trans }}
                      </div>
                  </div>
         
              
          

              <div class="row">
                <!-- <div class="col">
                  <button data-dismiss="modal" style="width:100%; margin-top:10px; padding:5px;" 
                  class="btn-close cursor-pointer"><h6 class="btn-save-text">Close</h6></button>
              </div> -->
                  <div class="col">
                      <button  (click)="create()" style="width:100%; margin-top:10px; padding:5px;" id="signupSubmit" 
                      type="submit" class="btn-save">
                          <h6 class="btn-save-text">{{ 'orguseradd.createuser' | trans }}</h6>
                        </button>
                  </div>

              </div>
             
  
          </form>
          </div>
        </div>
      </div>
      </div>
      </div>